import cx from 'helpers/cx'

import { Col } from 'js/components/Grid'

import styles from './Column.module.css'

type ColProps = React.ComponentProps<typeof Col>

const Column = ({ className, ...rest }: ColProps) => (
    <Col className={cx(styles.column, className)} {...rest} />
)

export default Column
